import { ReturnPolicy } from '../generated/types/globalTypes';

export const RETURN_POLICY_CODE_TO_KEY = {
  0: ReturnPolicy.full_refund,
  1: ReturnPolicy.site_credit,
  2: ReturnPolicy.final_sale,
  3: ReturnPolicy.extended_holidays,
  4: ReturnPolicy.full_refund_markdown,
  5: ReturnPolicy.site_credit_markdown
};
